import { useWindowSize } from "@vueuse/core";
import { computed } from "vue";

export function useMobile(device: "mobile" | "desktop") {
  const { width } = useWindowSize();

  const isMobile = computed(() => width.value <= 768 && device === "mobile");
  const isDesktop = computed(() => width.value > 768 && device === "desktop");

  return { isMobile, isDesktop };
}
